import { fmtTime } from "@/lib/gatePass";
import AuthPhoto from "@/components/gate/AuthPhoto";

const ACTION_TEXT = { exit: "EXIT RECORDED", return: "RETURN RECORDED" };
const thumb = "w-14 h-14 object-cover border border-canvas-line shrink-0";

export const ScanResult = ({ result }) => {
  if (!result) return null;
  if (!result.ok) {
    return (
      <div className="p-4 bg-[#fde8e8] border-2 border-[#b91c1c] text-[#7f1d1d]" data-testid="gate-scan-error">
        <div className="text-lg font-bold">NOT ALLOWED</div>
        <div className="text-sm mt-1">{result.error}</div>
      </div>
    );
  }
  const p = result.pass;
  const late = p.overdue;
  return (
    <div className={`p-4 border-2 ${late ? "bg-[#fff4e5] border-[#b45309]" : "bg-[#e7f6ee] border-[#047857]"}`} data-testid="gate-scan-success">
      <div className="text-lg font-bold">{ACTION_TEXT[result.action]} ✓</div>
      <div className="font-mono text-sm mt-1">{p.pass_no}</div>
      <div className="text-sm mt-2"><b>{p.vehicle_reg_no || "—"}</b> · {p.kind === "test_ride" ? `Test ride · ${p.technician}` : p.customer_name}</div>
      {result.action === "return" && (
        <div className={`text-sm mt-1 ${late ? "text-[#b45309] font-bold" : ""}`} data-testid="gate-scan-duration">
          Out {p.minutes_out} min · {p.km_driven} km {late ? `(over ${p.max_minutes} min limit)` : ""}
        </div>
      )}
      {result.action === "exit" && p.kind === "test_ride" && (
        <div className="text-sm mt-1">Must return within {p.max_minutes} min — scan again on return.</div>
      )}
    </div>
  );
};

const kmText = (p) => {
  if (p.kind !== "test_ride" || p.exit_odometer_km == null) return "";
  return p.return_odometer_km != null ? ` · ${p.exit_odometer_km}→${p.return_odometer_km} km (${p.km_driven} km)` : ` · exit ${p.exit_odometer_km} km`;
};

export const PassRow = ({ p }) => (
  <div className={`px-3 py-2.5 border-t border-canvas-line text-sm flex gap-3 ${p.overdue ? "bg-[#fde8e8]" : ""}`} data-testid={`gate-row-${p.id}`}>
    {(p.exit_photo_path || p.return_photo_path) && (
      <div className="flex gap-1">
        <AuthPhoto path={p.exit_photo_path} className={thumb} testId={`gate-exit-photo-${p.id}`} />
        <AuthPhoto path={p.return_photo_path} className={thumb} testId={`gate-return-photo-${p.id}`} />
      </div>
    )}
    <div className="flex-1 min-w-0">
      <div className="flex justify-between gap-2">
        <span className="font-mono text-xs truncate">{p.pass_no}</span>
        <span className={`text-[10px] font-mono uppercase px-1.5 border shrink-0 ${p.overdue ? "border-[#b91c1c] text-[#b91c1c]" : "border-canvas-line text-ink-muted"}`}>
          {p.overdue ? "late" : p.status}{p.minutes_out != null ? ` · ${p.minutes_out}m` : ""}
        </span>
      </div>
      <div className="text-xs text-ink-muted mt-0.5">
        <b className="text-ink">{p.vehicle_reg_no || "—"}</b> · {p.kind === "test_ride" ? p.technician : p.customer_name}
        {p.exit_at ? ` · out ${fmtTime(p.exit_at)}` : ""}{p.return_at ? ` · back ${fmtTime(p.return_at)}` : ""}{kmText(p)}
      </div>
    </div>
  </div>
);

export const LogRow = ({ e }) => (
  <div className="px-3 py-2.5 border-t border-canvas-line text-sm flex gap-3" data-testid={`gate-log-row-${e.id}`}>
    <AuthPhoto path={e.photo_path} className={thumb} testId={`gate-log-photo-${e.id}`} />
    <div className="flex-1">
      <div className="flex justify-between">
        <b className="font-mono">{e.vehicle_reg_no}</b>
        <span className={`text-[10px] font-mono uppercase px-1.5 border ${e.direction === "in" ? "border-[#047857] text-[#047857]" : "border-ink text-ink"}`}>{e.direction}</span>
      </div>
      <div className="text-xs text-ink-muted">{e.purpose} · {fmtTime(e.recorded_at)} · {e.recorded_by?.name}{e.notes ? ` · ${e.notes}` : ""}</div>
    </div>
  </div>
);
